module.exports = __webpack_public_path__ + "static/media/高分五号卫星载荷及配置表.c6a91f6b.png";